// tslint:disable: max-line-length
import { Component } from '@angular/core';
import { BuildingBlockControlBaseComponent } from '../building-block/building-block.types';

// import { ControlBaseComponent } from './control-base.component';

@Component({
  template: '',
  standalone: false
})
export class AutofillControlBaseComponent extends BuildingBlockControlBaseComponent {
  /** type of integration */
  public autofillType: string;

  private getFlag(flag: string, storage = 'ss'): boolean {
    return this.statefulService.wrap(`${storage}:${this.coAppSwitch}${this.autofillType}-${flag}`).valueString === 'true';
  }
  private setFlag(flag: string, value: boolean, storage = 'ss'): void {
    this.statefulService.wrap(`${storage}:${this.coAppSwitch}${this.autofillType}-${flag}`).value = value;
  }

  /**
   * flag for api call in progress
   */
  public get isInProgress(): boolean {
    return this.getFlag('is-in-progress');
  }
  public set isInProgress(value: boolean) {
    this.setFlag('is-in-progress', value);
  }

  /**
   * error pulling data
   */
  public get isError(): boolean {
    return this.getFlag('is-error');
  }
  public set isError(value: boolean) {
    this.setFlag('is-error', value);
  }
}
